export default {
    render(h) {
        const attrs = {
            src: this.src
        };
        const emptyFun = () => {};
        const on = {
            click: () => {
                this.$emit('click');
            },
            loadedmetadata: this.loadedmetadata || emptyFun,
            loadeddata: this.loadeddata || emptyFun,
            canplay: this.canplay || emptyFun,
            pause: this.pause || emptyFun,
            play: this.play || emptyFun,
            ended: this.ended || emptyFun,
            seeked: this.seeked || emptyFun,
            error: this.error || emptyFun
        };
        if (this.autoplay) {
            attrs.autoplay = 'autoplay';
        }
        if (this.loop) {
            attrs.loop = 'loop';
        }
        if (this.controls) {
            attrs.controls = 'controls';
        }
        if (this.playsinline) {
            attrs.playsinline = 'playsinline';
        }
        if (this.volume) {
            attrs.volume = this.volume; //添加音量配置项
        }
        return h('video', { attrs, on });
    },
    props: {
        src: {
            type: String,
            default: ''
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        playsinline: {
            type: Boolean,
            default: false
        },
        volume: {
            default: null
        },
        loadedmetadata: Function,
        loadeddata: Function,
        canplay: Function,
        pause: Function,
        play: Function,
        ended: Function,
        error: Function,
        seeked: Function
    },
    mounted() {
        if (this.muted) {
            this.$el.muted = true;
        }
    }
};
